import React, { useState, useEffect } from "react";
import {
    getEngineeringProjectsAPI, importMilestoneToProjectAPI
} from "@/services"
import { useRequest } from "ahooks"
import { Modal, Select, Button, message } from 'antd'
import { useParams } from 'react-router-dom'

interface IProps{
    onImportSuccess: () => void
}

export default function ImportMilestone(props: IProps) {
    const { onImportSuccess } = props
    const params = useParams()
    const projectID = params.projectID || ""
    const [modalVisible, setModalVisible] = useState(false)
    const [selectedProjectId, setSelectedProjectId] = useState<number | null>(null)
    const [engineeringProjects, setEngineeringProjects] = useState<API.PROJECT.EngineeringProject[]>([])
    const [loading, setLoading] = useState(false)

    const { run: fetchEngineeringProjects } = useRequest(
        () => getEngineeringProjectsAPI(projectID),
        {
            manual: true,
            onSuccess: (data) => {
                setEngineeringProjects(data)
            },
            onError: () => {
                message.error('获取工程项目列表失败')
            }
        }
    )

    const { run: importMilestone } = useRequest(
        (thirdPartyProjectId: number) => importMilestoneToProjectAPI(projectID, thirdPartyProjectId),
        {
            manual: true,
            onSuccess: () => {
                message.success('导入里程碑成功')
                onImportSuccess()
                setModalVisible(false)
                setSelectedProjectId(null)
            },
            onError: () => {
                message.error('导入里程碑失败')
            }
        }
    )

    const handleOpenModal = () => {
        setSelectedProjectId(null)
        fetchEngineeringProjects()
        setModalVisible(true)
    }

    const handleConfirm = () => {
        if (!selectedProjectId) {
            message.warning('请选择工程项目')
            return
        }
        importMilestone(selectedProjectId)
    }

    const handleCancel = () => {
        setModalVisible(false)
        setSelectedProjectId(null)
    }

    return (
        <>
            <Button
                onClick={handleOpenModal}
                size="small"
                className="text-xs ml-2"
            >
                导入同工程项目里程碑
            </Button>

            <Modal
                title="选择工程项目"
                open={modalVisible}
                onOk={handleConfirm}
                onCancel={handleCancel}
                confirmLoading={loading}
                okText="确定"
                cancelText="取消"
                width={600}
            >
                <div className="py-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        工程项目
                    </label>
                    <Select
                        placeholder="请选择工程项目"
                        value={selectedProjectId}
                        onChange={setSelectedProjectId}
                        className="w-full"
                        options={engineeringProjects.map((project) => ({
                            label: project.name || `项目 ${project.id}`,
                            value: project.id
                        }))}
                    />
                </div>
            </Modal>
        </>
    )
}
